import { createContext } from 'react';

const BillingConfigurationContext = createContext();

export default BillingConfigurationContext;
